interface PublishHeaderProps {
  activePresetLabel: string
  hasPendingChange: boolean
  isPublishing: boolean
  isLoading: boolean
  onPublish: () => void
  onCancel: () => void
}

export function PublishHeader({
  activePresetLabel,
  hasPendingChange,
  isPublishing,
  isLoading,
  onPublish,
  onCancel,
}: PublishHeaderProps) {
  return (
    <div className="mb-5 flex items-start justify-between">
      <div>
        <h2 className="text-lg font-semibold">ดีไซน์มือถือ</h2>
        <p className="mt-0.5 text-xs text-gray-500">เลือกสไตล์ร้านค้าบนมือถือ</p>
      </div>
      {!isLoading && !hasPendingChange && (
        <span className="rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-700">
          Active: {activePresetLabel}
        </span>
      )}
      {hasPendingChange && (
        <div className="hidden items-center gap-2 md:flex">
          <button
            type="button"
            onClick={onCancel}
            disabled={isPublishing}
            className="rounded-md px-3 py-1.5 text-xs text-gray-600 transition-colors motion-reduce:transition-none hover:text-gray-900 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
          >
            ยกเลิก
          </button>
          <button
            type="button"
            onClick={onPublish}
            disabled={isPublishing}
            className="rounded-sm bg-blue-600 px-4 py-1.5 text-xs font-semibold text-white transition-colors motion-reduce:transition-none hover:bg-blue-700 disabled:opacity-70 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
          >
            {isPublishing ? 'กำลังบันทึก...' : 'เผยแพร่'}
          </button>
        </div>
      )}
    </div>
  )
}
